var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"el-form",class:_vm.className,on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }